import { Button, styled } from '@mui/material';

export const ButtonFilter = styled(Button, {
  shouldForwardProp: prop => prop !== 'isMobileOrTablet',
})<{ isMobileOrTablet: boolean }>(({ isMobileOrTablet }) => ({
  padding: isMobileOrTablet ? 0 : undefined,
  width: isMobileOrTablet ? 'fit-content' : '100%',
}));
